app.controller('popupIcfGraphController', ['$scope', '$state', '$mdDialog', '$timeout', 'objectHelper', 'baseModel', 'applicationModel', 'icfDiagnosis',
    function ($scope, $state, $mdDialog, $timeout, objectHelper, baseModel, applicationModel, icfDiagnosis) {

        function setData() {
            $scope.icfData = icfDiagnosis;

            $scope.dbsList = [];
            $scope.eList = [];

            $scope.icfData.forEach(function(element) {
                var elementType = element.icf.value.substr(0,1);
                if(elementType === 'b' || elementType === 'd' || elementType === 's') {
                    $scope.dbsList.push(element);
                }
                if(elementType === 'e') {
                    $scope.eList.push(element);
                }
            })

        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.getFlexValue = function(localIcfDiagnosis) {
                var num = 0;
                var icfNumber = parseInt(localIcfDiagnosis.firstQualifier.value.substr(1,2), 10);
                if($scope.isPlusType(localIcfDiagnosis)) {
                    if(icfNumber === 1) {
                        num = 25;
                    }
                    if(icfNumber === 2) {
                        num = 50;
                    }
                    if(icfNumber === 3) {
                        num = 75;
                    }
                    if(icfNumber >= 4) {
                        num = 100;
                    }
                } else {
                    if(icfNumber === 0) {
                        num = 20;
                    }
                    if(icfNumber === 1) {
                        num = 40;
                    }
                    if(icfNumber === 2) {
                        num = 60;
                    }
                    if(icfNumber === 3) {
                        num = 80;
                    }
                    if(icfNumber >= 4) {
                        num = 100;
                    }
                }
                return num;
            };

            $scope.isPlusType = function(localIcfDiagnosis) {
                return localIcfDiagnosis.firstQualifier.value[0] == "+";
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);